<div class="process-builder">
    <app-spinner
            [isEnable]="isSpinnerEnable"
            loaderClass="create-process-spinner"></app-spinner>
    <div class="row">
        <div class="head-component m-b-25">
            <div class="col-10 br-0 p-l-20 m-0 p-r-45 head-component for-fixed-component card">
                <div class="pl-0 pr-0 card-body d-flex align-items-center">
                    <div class="col-12 pl-0 p-r-10 d-flex justify-content-between align-items-center">
                        <div class="float-left">
                            <h5 class="mb-0">
                                <span class="head-main-component" [routerLink]="['/admin/processes-list']">
                                    Processes
                                    <i class="mdi mdi-chevron-right"></i>
                                </span>
                                <span>
                                    {{getProcessName()}}
                                </span>
                            </h5>
                        </div>
                        <div class="float-right mt-1" *ngIf="processId && process?.stage == processStage.Draft">
                            <span (click)="openConfirmationModal(importConfirmationModal)">
                                Import from Excel
                            </span>
                            <span (click)="downloadFile()">
                                Export to Excel
                            </span>
                            <span class="create-process lh-1-3" (click)="openConfirmationModal(approveModal)">
                                Finalize process
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="process" class="row p-l-10 p-b-20">
        <div class="col-5 pr-0">
            <div class="card mb-2">
                <div class="card-body base-shadow-list p-t-10 p-b-10">
                    <app-process-general-info [process]="process"></app-process-general-info>
                </div>
            </div>
            <div class="card mb-2">
                <div class="card-body base-shadow-list p-t-10 p-b-10">
                    <app-appraisee [process]="process"></app-appraisee>
                </div>
            </div>
            <div class="card mb-2">
                <div class="card-body base-shadow-list p-t-10 p-b-10">
                    <app-respondents-selection [process]="process"></app-respondents-selection>
                </div>
            </div>
            <div class="card mb-2">
                <div class="card-body base-shadow-list p-t-10 p-b-10">
                    <app-process-settings [process]="process"></app-process-settings>
                </div>
            </div>
            <div class="card mb-2">
                <div class="card-body base-shadow-list p-t-10 p-b-10">
                    <app-process-report-settings [process]="process"></app-process-report-settings>
                </div>
            </div>
            <div class="card mb-2">
                <div class="card-body base-shadow-list p-t-10 p-b-10">
                    <app-notifications [process]="process"></app-notifications>
                </div>
            </div>

            <!--Recuring settings. Will be implemented. Do to remove-->
            <!-- <div class="card mb-2">
                <div class="card-body pt-2 pb-2">
                    <app-repeatable-process [process]="process"></app-repeatable-process>
                </div>
            </div> -->
            <button class="btn waves-light btn-block btn-info col-2 create-process float-right" id="btn_save_process"
                    [disabled]="isOnSaving || process.stage != processStage.Draft" (click)="onSaveClicked()">Save
            </button>
            <button class="btn waves-light btn-info create-process float-right" [disabled]="process.stage != processStage.Draft" (click)="onPickRespondentsClicked()">
                Select respondents
            </button>
        </div>
        <div class="col-7 p-l-25">
            <app-respondent-edit-list *ngIf="process.firstDuration && process.firstDuration.id"
                                      [minRespondentAmount]="process.minRespondentAmount"
                                      [processParticipators]="processParticipators"
                                      [processDurationId]="process.firstDuration.id"
                                      [allowSelfAssesment]="process.allowSelfAssesment"
                                      (appraiseeChanged)="removeProcessParticipations($event)"
                                      [respondentSelectionValues]="process.respondentSelectionValues"
                                      [knownProcessTypes]="process.processKnownTypes">
            </app-respondent-edit-list>
        </div>
    </div>
</div>
<ng-template #approveModal>
    <div>
        <div class="modal-body">
            <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="d-flex justify-content-center flex-column" style="min-height: 85px;">
                <div>
                    Please, make sure that changes was saved. Do you really want to continue?
                </div>
            </div>
            <div class="btn-modal">
                <span (click)="finalizeProcess()">Yes</span>
                <span (click)="modalRef.hide()">No</span>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #importConfirmationModal>
    <div>
        <div class="modal-body">
            <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="d-flex justify-content-center flex-column" style="min-height: 85px;">
                <div>
                    All appraisees and respondents would be overwritten by data from the file. Do you really want to
                    continue?
                </div>
            </div>
            <div class="btn-modal">
                <span class="ok-button">
                    <label class="ok-button-label text-center" for="file">
                        Yes
                    </label>
                    <input type="file" id="file" (change)="getFile($event)" #fileInput required/>
                </span>
                <span class="no-button" (click)="modalRef.hide()">No</span>
            </div>
        </div>
    </div>
</ng-template>

